import React from 'react';
import './_REDropdown.scss';
import { useTranslation } from 'react-i18next';

const REDropdown = (props) =>{
    const { t } = useTranslation();
    const { showVoiceWarning, closeToggle, toggleDropdown, data, index, returnData, toggle_index } = props;
    const shouldAddHandlers = showVoiceWarning !== false;

    const dropdownProps = shouldAddHandlers
        ? {
            onClick: () => toggleDropdown(data.id),
            onMouseLeave: closeToggle ? () => toggleDropdown(data.id) : null
        }
        : {};
    const isVolumeZero = showVoiceWarning === false && data.data === t("RESIDENTS_SETTING.SENSOR.OFF");
    const displayText = isVolumeZero ? t("RESIDENTS_SETTING.SENSOR.SILENCE") : data.data;
    return(
        <>
            <div className="wrap-REDropdown">
            <div className={`dropdown ${closeToggle ? 'active' : ''}`}
                {...dropdownProps}
            >

                <div className="fx-d-r">

                    {/* 選單內容 */}
                    <div className="dropdown_header">
                        {/* 呈現最終結果位置 */}
                        <div className={`fx-d-c fx-ccc ${isVolumeZero && 'font-grey'}`}
                            data-index={index}
                            data-group="dropdown">
                            {displayText}
                        </div>
                        {/* 下底線 */}
                        {/* <div className="line"></div>  */}
                    </div>

                    {/* 下拉圖示 */}
                    {shouldAddHandlers && (
                        <div className="wid-10 fx-d-c fx-ccc">
                            <div className={`tri ${closeToggle ? 'rotate' : ''}`}></div>
                        </div>
                    )}
                </div>

                {/* 列表空間 */}
                <div className="fx-d-c fx-nnfe w-100" >
                    {/* 隱藏列表的空間 */}
                    <div className={`dropdown_body fx-ccc w-100 ${closeToggle ? 'active' : 'none'}`}>
                        {/* 列表的內容 */}
                        <div className="dropdown-scrollable div_display">
                            {
                                data.keys.map((dcg, index) =>
                                    <ul id={`${data.id}-${index}`}
                                        key={`${data.id}-${index}`}
                                        onClick={()=>returnData(dcg)}
                                        >
                                        <li>
                                            <div className={`dropdown-item `}
                                                id={`${data.id}-item_${toggle_index}-${index}`}
                                                key={`${data.id}-item_${toggle_index}-${index}`}
                                                href="#"
                                            >
                                                {dcg}
                                            </div>
                                        </li>
                                    </ul>
                                )
                            }
                        </div>
                    </div>
                </div>

            </div>
            </div>
        </>
    )
}
export default REDropdown